import { SmartPhones } from "../../components";
import "./stylesCategoriaSmartphones.scss";

export const CategoriaSmartphones = () => (
  <div>
    <SmartPhones />
  </div>
);
